export enum ButtonState {
    Enabled = 0,
    Disabled = 1,
    Hover = 2,
    Down = 3,
    Win = 4
}

export class Button extends Phaser.GameObjects.Container {

    public buttonFunction: () => void;
    public buttonBase: Phaser.GameObjects.Image;
    public buttonIcon: Phaser.GameObjects.Image;

    public normalTexture: string;
    public hoverTexture: string;
    public downTexture: string;
    public disabledTexture: string;
    
    public spriteSheet: string;

    protected buttonIconTexture: string;


    constructor(scene: Phaser.Scene, x: number, y: number, spriteSheet: string, normalTexture: string, hoverTexture: string, downTexture: string, disabledTexture: string, buttonIconTexture: string | null, enabled: boolean = true) {
        super(scene, x, y);

        this.spriteSheet = spriteSheet;

        this.normalTexture = normalTexture;
        this.hoverTexture = hoverTexture;
        this.downTexture = downTexture;
        this.disabledTexture = disabledTexture;
        this.buttonIconTexture = buttonIconTexture;

        this.buttonBase = new Phaser.GameObjects.Image(scene, 0, 0, spriteSheet, normalTexture);
        this.buttonBase.setOrigin(0);
        this.add(this.buttonBase);

        if (buttonIconTexture != null) {
            this.buttonIcon = new Phaser.GameObjects.Image(scene, 0, 0, spriteSheet, buttonIconTexture);
            this.buttonIcon.setOrigin(0.5);
            this.add(this.buttonIcon);
        }

        this.state = ButtonState.Enabled;
        this.setDisabled(!enabled);
    }

    public ResizeAndMove(x: number, y: number, width: number, height: number) {
        this.x = x;
        this.y = y;

        this.width = width;
        this.height = height
        this.buttonBase.setDisplaySize(this.width, this.height);

        if (this.buttonIcon) {
            this.buttonIcon.scale = this.buttonBase.scale;
            this.buttonIcon.x = width / 2;
            this.buttonIcon.y = height / 2;
        }
    }

    public setDisabled(disabled: boolean): void {
        if (disabled) {
            this.state = ButtonState.Disabled;
            this.buttonBase.setTexture(this.spriteSheet, this.disabledTexture);
            if (this.buttonIcon)
                this.buttonIcon.tint = 0x3b3b3b;
            this.buttonBase.removeInteractive();
        }
        else {
            this.state = ButtonState.Enabled;
            this.buttonBase.setTexture(this.spriteSheet, this.normalTexture);
            if (this.buttonIcon)
                this.buttonIcon.clearTint();
            this.buttonBase.setInteractive()
                .on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.handleUp, this)
                .on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, this.handleOut, this)
                .on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handleDown, this)
                .on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, this.handleOver, this)
        }
    }

    private handleUp(pointer: Phaser.Input.Pointer): void {
        this.state = ButtonState.Enabled;
        this.buttonBase.setTexture(this.spriteSheet, this.normalTexture);
        if (this.buttonFunction)
            this.buttonFunction();
    }

    private handleOut(pointer: Phaser.Input.Pointer): void {
        this.state = ButtonState.Enabled;
        this.buttonBase.setTexture(this.spriteSheet, this.normalTexture);
    }

    private handleDown(pointer: Phaser.Input.Pointer): void {
        this.state = ButtonState.Down;
        this.buttonBase.setTexture(this.spriteSheet, this.downTexture);
    }

    private handleOver(pointer: Phaser.Input.Pointer): void {
        this.state = ButtonState.Hover;
        this.buttonBase.setTexture(this.spriteSheet, this.hoverTexture);
    }
}